module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="gmf-theme-selector">\n  <li\n    ng-repeat="theme in $ctrl.themes"\n    ng-click="$ctrl.setTheme(theme)"\n    ng-class="{\'gmf-theme-selector-active\': $ctrl.gmfThemeManager.getThemeName() == theme.name}"\n  >\n    <img class="gmf-thumb" ng-src="{{::theme.icon}}" />\n    <span class="gmf-text">{{theme.name | translate}}</span>\n  </li>\n</ul>\n';

}
return __p
}